import React, {useState} from 'react';
import Layout from './../../components/Layout/Layout.js'
import axios from "axios";
import {useNavigate,useLocation} from 'react-router-dom'
import toast from 'react-hot-toast';
import '../../style/AuthStyle.css';
import {useAuth} from '../../context/auth';
import { SERVER_API } from '../../fileWithConstants.js';
const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [auth, setAuth] = useAuth();
    const navigate = useNavigate();
	const location = useLocation();
    const handleSubmit = async (e)=>{
                                        e.preventDefault();
                                        //console.log(name,email,password,phone,address); return false;
                                        try {
                                        const res = await axios.post(`${SERVER_API}/api/v1/auth/login`,{email,password})
                                        if(res.data.success){
                                            toast.success(res.data.message)
                                            setAuth({
                                                ...auth,
                                                user:res.data.user,
                                                token:res.data.token
                                            })
                                            console.log(res.data);
                                            localStorage.setItem('auth',JSON.stringify(res.data))
                                            //navigate('/')
											navigate(location.state || "/");
                                        }else{
                                            toast.error(res.data.message)
                                        }
                                        } catch (error) {
                                        console.log(error)
                                        }
                                }
  return (
    <Layout title={"Login"}>
        <div className='form-container'>
            <form onSubmit={handleSubmit} className='form-section'>
                <h4 className='title'>Sign in</h4>
                <div className='form-box'>
                <div className="mb-3">
                    <input type="email" className="form-control" placeholder='Enter your email' value={email} onChange={(e)=>setEmail(e.target.value)} required />
                </div>
                <div className="mb-3">
                    <input type="password" className="form-control" placeholder='Enter your password' value={password} onChange={(e)=>setPassword(e.target.value)} required />
                </div>
                <div className='submit-button-box'><button type="submit" className="btn btn-primary">LOGIN</button></div>
                </div>                
            </form>
        </div>
    </Layout>
  )
}
export default Login